import { FC } from 'react';

import './header.scss';
import { Image, Span } from 'components/helpers';
import { translations } from 'translations/en';
import Buttons from './Buttons';
import PremiumIcon from 'photos/premium.png';
import { IProfileHeader } from 'types';
import ProfileAvatar from './ProfileAvatar';

const { FOLLOWING, FOLLOWERS, FOLLOWER } = translations.COMMON;

const Header: FC<IProfileHeader> = ({
  shouldDisplayLottie,
  name,
  totalFollowing,
  totalFollowers,
  username,
  avatar,
  isLoggedInUser,
  isOnline,
  onAvatarChange,
  isFollowing,
  onFollowToggle,
  onMessageClick,
  bio,
  onEdit,
  isPremium,
  isLoading,
}) => {
  const followersText = totalFollowers === 1 ? FOLLOWER : FOLLOWERS;

  const renderTotalText = (total: number, text: string) => (
    <div className="total-text">
      <Span text={total} className="total" />
      <Span text={text} className="text" />
    </div>
  );

  return (
    <div className="profile-header">
      <div className="content">
        <ProfileAvatar
          key={avatar}
          isLoading={isLoading}
          isLoggedInUser={isLoggedInUser}
          avatar={avatar}
          shouldDisplayLottie={shouldDisplayLottie}
          isOnline={isOnline}
          onAvatarChange={onAvatarChange}
        />
        <div className="details">
          <div className="row">
            <Span text={name} className="title" />
            {isPremium && <Image src={PremiumIcon} />}
          </div>
          <Span text={`@${username}`} className="sub-title" />
          <div className="totals-text-container">
            {renderTotalText(totalFollowing, FOLLOWING)}
            <Span className="line" text="|" />
            {renderTotalText(totalFollowers, followersText)}
          </div>
        </div>
        <Buttons
          onEdit={onEdit}
          isLoggedInUser={isLoggedInUser}
          onFollowToggle={onFollowToggle}
          isFollowing={isFollowing}
          onMessageClick={onMessageClick}
        />
      </div>
      {bio && (
        <div className="bio-container">
          <div className="row">
            <Span text={translations.PROFILE.BIO} className="title" />
          </div>
          <Span text={bio} className="text" />
        </div>
      )}
    </div>
  );
};

export default Header;
